import React, { useEffect } from 'react';
import {BrowserRouter, Route, Routes } from 'react-router-dom'; //Navigate
import * as ROUTES from './constants/routes'
import HomePage from './pages/Home';
import "./css/Swiper.css"
import "./css/Popup.css"
import "./css/Animations.css"
import "./css/Style.css"
import "./css/Calculator.css"
import "./css/Dashboard.css"
import "./css/SuccessLoanForm.css"
import "./css/BecomeMemberForm.css"
import "./css/TransitionPage.css"

import { ThemeProvider } from "@mui/styles";
import { createTheme } from '@mui/material/styles';
import './font-awesome-4.7.0/css/font-awesome.min.css'
import './font-awesome-4.7.0/css/font-awesome.css'
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import BecomeAMember from './pages/BecomeAMember';
import ContactUs from './pages/ContactUs';
import HolidaySchedule from './pages/HolidaySchedule';
import LoanRates from './pages/LoanRates';
import LoadApplication from './pages/LoadApplication';
import DepositeRate from './pages/DepositeRate';
import CheckingAccounts from './pages/CheckingAccounts';
import CreditCard from './pages/CreditCard';
import CUService from './pages/CUService';
import ATMLocator from './pages/ATMLocator';
import Calculator from './pages/Calculator';
import MainCalculator from './pages/MainCalculator';
import PromotionPage from './pages/Promotions';
import SearchResult from './pages/SearchResult';
import SiteMap from './pages/SiteMap';
import SuccessLoadForm from './pages/SuccessLoanForm';
import BecomeMemberForm from './pages/BecomeMemberForm';
import Notfound404 from './pages/NotFound404';



const App: React.FC =()=> {


  let theme = createTheme({
    breakpoints: {
      values: {
        xs: 0, // Extra small
        sm: 600, // Small
        md: 900, // Medium
        lg: 1200, // Large
        xl: 1536, // Extra large
        // Add custom breakpoints here (e.g., xxl: 1800)
      }
    },
  });


  /*
=============================================================== 
//* AOS iNIT
===============================================================
*/
useEffect(()=> {
  AOS.init({
    duration: 400,
    easing: 'ease-in-sine',
    delay: 0,
    once: true,
  })
  AOS.refresh()

  return () => {
    AOS.refresh()
  }
}, [])


  return (
      <ThemeProvider theme={theme}>
        <div className="App">
      
          <BrowserRouter>
            <Routes>
              <Route path={ROUTES.HOME} element={<HomePage />}/>
              <Route path={ROUTES.BECOME_A_MEMBER} element={<BecomeAMember />}/>
              <Route path={ROUTES.CONTACT_US} element={<ContactUs />}/>
              <Route path={ROUTES.HOLIDAY_SCHEDULE} element={<HolidaySchedule />}/>
              <Route path={ROUTES.LOAN_RATES} element={<LoanRates />}/>
              <Route path={ROUTES.LOAN_APPLICATION} element={<LoadApplication />}/>
              <Route path={ROUTES.DEPOSITE_RATES} element={<DepositeRate />}/>
              <Route path={ROUTES.CHECKING_ACCOUNTS} element={<CheckingAccounts />}/>
              <Route path={ROUTES.CREDIT_CARDS} element={<CreditCard />}/>
              <Route path={ROUTES.CU_SERVICE} element={<CUService />}/>
              <Route path={ROUTES.ATM_LOCATOR} element={<ATMLocator />}/>
              <Route path={ROUTES.CALCULATOR} element={<Calculator />}/>
              <Route path={ROUTES.MAIN_CALCULATOR} element={<MainCalculator />}/>
              <Route path={ROUTES.PROMOTION} element={<PromotionPage />}/>
              <Route path={ROUTES.SITE_MAP} element={<SiteMap />}/>
              <Route path={ROUTES.SUCCESS_LOAN_FORM} element={<SuccessLoadForm />}/>
              <Route path={ROUTES.BECOME_A_MEMBER_FORM} element={<BecomeMemberForm />}/>        
              <Route path='/mcu-search-results/:search' element={<SearchResult />}/>
              
              <Route path='*' element={<Notfound404 />}/>
      
            </Routes>
          </BrowserRouter>

        </div>
      </ThemeProvider>
  );
}

export default App;
